import { CheckListTaskEntity } from 'backend-entity';

export type CrmPatchCheckListStartTaskRequestDto = Pick<CheckListTaskEntity, 'technicId'>;
